export const OPTION_UNIT_RESTRICTION_STATUS = {
  VALID: 'valid',
  SHORTAGE: 'shortage',
  EXCESS: 'excess',
  /** A restricted product whose plan still has no participants. */
  MAIN_QUANTITY_MISSING: 'mainQuantityMissing'
} as const;

export type OptionUnitRestrictionStatus =
  (typeof OPTION_UNIT_RESTRICTION_STATUS)[keyof typeof OPTION_UNIT_RESTRICTION_STATUS];
